import * as Yup from "yup";

/*
 * The single password rule for every screen that sets a password. The character classes
 * are ASCII on purpose, to match ASP.NET Core Identity, and this must change together
 * with the API's password options in Program.cs.
 */
export const PASSWORD_MIN_LENGTH = 8;

const newPassword = () =>
  Yup.string()
    .required("Password is required")
    .min(
      PASSWORD_MIN_LENGTH,
      `Password must be at least ${PASSWORD_MIN_LENGTH} characters`
    )
    .matches(/[A-Z]/, "Password must include an uppercase letter")
    .matches(/[a-z]/, "Password must include a lowercase letter")
    .matches(/[0-9]/, "Password must include a number")
    .matches(/[^A-Za-z0-9]/, "Password must include a symbol");

export const loginValidator = () => {
  return Yup.object({
    emailOrUsername: Yup.string()
      .required("Email or username is required")
      .test(
        "email-or-username",
        "Invalid email address or username",
        function (value) {
          if (!value) return false;
          if (value.includes("@")) {
            return Yup.string().email().isValidSync(value);
          }
          return true;
        }
      ),
    password: Yup.string().required("Password is required"),
  });
};

export const ResetPasswordValidator = () => {
  return Yup.object({
    // Not .email(): the field accepts a username or an email.
    Email: Yup.string().required("Username or email is required"),
  });
};

export const ForgotPasswordValidator = () => {
  return Yup.object({
    password: newPassword(),
    password__c: Yup.string()
      .required("Password confirmation is required")
      .oneOf([Yup.ref("password"), null], "Passwords must match"),
  });
};

// update password
export const UpdatePasswordValidator = () => {
  return Yup.object({
    password: newPassword(),
    password__c: Yup.string()
      .required("Password confirmation is required")
      .oneOf([Yup.ref("password"), null], "Passwords must match"),
  });
};

export const NewPasswordValidator = () => {
  return Yup.object({
    newPassword: newPassword(),
  });
};

export const checkPasswordQuality = (password: string) => {
  return newPassword().isValidSync(password);
};

export const UpdateUserPasswordValidator = () => {
  return Yup.object({
    // Only required: older passwords may not meet the current rule.
    oldPassword: Yup.string().required("Old password is required"),
    newPassword: newPassword(),
    confirmPassword: Yup.string()
      .oneOf([Yup.ref("newPassword"), null], "Passwords must match")
      .required("Confirm Password is required"),
  });
};
